module.exports = __webpack_public_path__ + "img/tarj1-2.3f99447f.svg";